<template>
  <div class="about-box">
    <div class="banner">
      <div class="content-1200 H100 flex-column flex-centent">
        <div class="title fontWeight-800 fontSize48">关于我们</div>
        <div class="desc fontSize16 color-level4">
          金标联盟致力于推动标准统一，更好的服务开发者和推动行业标准化和一体化
        </div>
      </div>
    </div>
    <reveal-animation>
      <section class="section-title">
        移动智能终端生态专业委员会
      </section>
      <section class="content-block flex-nowrap">
        <img src="@/assets/img/about/content-img.png" alt="" class="content-img">
        <div class="content-txt">
          <p>
            移动智能终端生态专业委员会（简称"金标联盟"，英文简称ITGSA）成立于2021年，是由国家产业政策引导、市场需求驱动的创新型行业组织。
          </p>
          <p>
            联盟以服务开发者为核心，聚焦智能终端软件生态体系构建与技术标准研制，围绕成员需求探索创新生态模式，着力强化产业核心竞争力，驱动技术革新与效能突破，加速新技术与新业态深度融合。通过整合生态资源，系统开展技术标准研究、关键技术攻关及场景应用实践，构建全链条生态服务体系，打造智能终端软件生态，提供全方位服务赋能优质生态发展。
          </p>
        </div>
      </section>
    </reveal-animation>

    <reveal-animation>
      <Members :partnersList="partnersList"/>
    </reveal-animation>

    <reveal-animation>
      <div class="jiagou-box">
        <section class="jiagou-title">
          联盟架构
        </section>
        <el-image :src="require('@/assets/img/about/jiagou.png')" width="100%" lazy></el-image>
      </div>
    </reveal-animation>


    <div class="foot-box">
      <reveal-animation :options="{duration:1000,delay:0}">
        <div>
          <h3 class="foot-title">移动智能终端生态专业委员会章程</h3>
          <p class="foot-msg">
            联盟设理事长、理事单位、生态单位、合作伙伴四类会员，分别享有参与决策、标准制定、资源共享等权益，需履行维护联盟声誉、保密等义务。组织架构含理事长会、秘书处及标准、职能工作组，负责战略决策、日常运营及技术攻关。经费由成员分担，用于运维与活动，资产受监管。详细章程介绍请点击《移动智能终端生态专业委员会章程》进行查阅。</p>
          <a class="foot-btn" href="/home/constitution" target="_blank">
            点击查看
          </a>
        </div>
      </reveal-animation>
    </div>

  </div>
</template>

<script>
import RevealAnimation from "@/components/common/RevealAnimation";
import Members from "@/views/index/components/Members";
import {singleHomeSever} from "@/common/api-config";
import MoreButton from "@/components/common/MoreButton.vue";

export default {
  metaInfo: {
    title: "ITGSA | 移动智能终端生态专业委员会 | 关于我们",
    meta: [
      {
        name: 'keywords',
        content: 'ITGSA,理事会成员,战略生态合作伙伴,注册籍会员，移动智能终端生态专业委员会章程'
      },
      {
        name: 'description',
        content: '以国家产业政策为导向，以市场为驱动，以服务开发者企业为主体，搭建搭载智能终端的软件生态平台和技术标准。促进联盟成员企业的软件生态研发、设计、集成、服务等水平，探索和构建智能终端产业的下一代软件生态，提升我国智能终端软件产业的竞争力，促进技术进步、提高生产效率，支持新技术、新产业、新业态、新模式的加快发展。'
      },
    ]
  },
  components: {MoreButton, RevealAnimation, Members},
  data() {
    return {
      partnersList: [],
    };
  },
  created() {
    this.queryAllianceMemberList();
  },
  methods: {
    queryAllianceMemberList() {
      singleHomeSever.queryAllianceMemberList({}).then(res => {
        if (res.code == 0) {
          this.partnersList = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.about-box {
  width: 100%;
  height: 100%;
  background-color: #FAFAFA;

  .banner {
    width: 100%;
    height: 600px;
    background-image: url("~@/assets/img/about/about-banner.jpg");
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;

    .title {
      margin-bottom: 12px;
      background: linear-gradient(359.9999999898547deg, #F5CE99 0%, #FFF2C6 52%, #F5CE99 100%);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      -webkit-text-fill-color: transparent;
    }

    .desc {
      width: 644px;
      margin-bottom: 32px;
      line-height: 27px;
    }

    .more-btn {
      background: linear-gradient(90deg, #F5CE99 0%, #FFF2C6 52%, #F5CE99 100%);
      border: 1px solid transparent;
      margin: initial;
    }
  }

  .section-title {
    margin-top: 80px;
    margin-bottom: 60px;
    font-size: 36px;
    color: #333333;
    line-height: 42px;
    text-align: center;
    font-weight: 800;
  }

  .content-block {
    width: 1200px;

    .content-img {
      width: 400px;
      height: 200px;
    }

    .content-txt {
      padding-top: 31px;
      margin-left: 40px;

      p {
        margin-bottom: 20px;
        font-size: 14px;
        color: #666666;
        line-height: 24px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }

  }

  .jiagou-box {
    width: 1140px;
    margin: auto;

    .jiagou-title {
      margin-top: 40px;
      margin-bottom: 57px;
      font-size: 36px;
      color: #333333;
      line-height: 42px;
      text-align: center;
      font-weight: 800;
    }
  }

  .foot-box {
    display: block;
    margin: auto;
    margin-top: 80px;
    width: 100%;
    height: 353px;
    padding-top: 80px;
    background-image: url(~@/assets/img/about/zhangcheng-bg.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    .foot-title {
      width: 360px;
      margin: auto;
      font-size: 24px;
      line-height: 28px;
      font-weight: 800;
      color: #f2e9c1;
      background: linear-gradient(to right, #F5CE99 0%, #f2e9c1 50%, #F5CE99 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
    }

    .foot-msg {
      width: 835px;
      margin: auto;
      margin-top: 20px;
      color: #B2B2B2;
      font-size: 16px;
      line-height: 28px;
    }

    .foot-btn {
      display: block;
      margin: auto;
      margin-top: 40px;
      width: 160px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: linear-gradient(90deg, #F5CE99 10%, #FFF2C6 50%, #F5CE99 90%);
      border-radius: 60px;
      font-weight: bold;
      font-size: 14px;
    }
  }
}

</style>
